export default "__VITE_ASSET__CDbb$k8R__"